import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GlobalProvider } from './context/GlobalContext';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import PageNotFound from './pages/PageNotFound';
import Loader from './components/Loader';

function App() {
    return (
        <main className='w-full max-w-screen-2xl'>
            <BrowserRouter>
                <GlobalProvider>
                    <Loader />
                    <Routes>
                        <Route path='*' element={<PageNotFound />} />
                        <Route path='/' element={<LandingPage Home />} />
                        <Route path='/login' element={<LandingPage Login />} />
                        <Route
                            path='/register'
                            element={<LandingPage Register />}
                        />
                        <Route
                            path='/job-detail/:jobId'
                            element={<LandingPage Detail />}
                        />
                        <Route path='/dashboard' element={<Dashboard Home />} />
                        <Route
                            path='/dashboard/job-vacancy-list'
                            element={<Dashboard JobList />}
                        />
                        <Route
                            path='/dashboard/job-vacancy-list/form'
                            element={<Dashboard Post />}
                        />
                        <Route
                            path='/dashboard/job-vacancy-list/form/:IdData'
                            element={<Dashboard Post />}
                        />
                        <Route
                            path='/dashboard/profile'
                            element={<Dashboard Profile />}
                        />
                        <Route
                            path='/dashboard/change-password'
                            element={<Dashboard Password />}
                        />
                        <Route
                            path='/dashboard/log-out'
                            element={<Dashboard Logout />}
                        />
                    </Routes>
                </GlobalProvider>
            </BrowserRouter>
        </main>
    );
}

export default App;
